import { FC } from 'react';

// Third-party
import ListItem from '@mui/material/ListItem';
import SvgIcon from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';
import { Draggable } from 'react-beautiful-dnd';

// Types
import { TDraggableTasks } from '../type';

// Assets
import { ReactComponent as TrashIcon } from '../../../../static/icons/ic_trash.svg';
import { ReactComponent as DragIcon } from '../../Shared/static/ic_drag.svg';

const DraggableTasks: FC<TDraggableTasks> = ({ tasks, onDeleteTask }) => (
  <div>
    {tasks?.map((task, index) => (
      <Draggable key={task.taskName} draggableId={task.taskName} index={index}>
        {(provided) => (
          <ListItem
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            key={task.index}
            className="cursor-pointer"
            alignItems="flex-start"
            secondaryAction={(
              <SvgIcon
                onClick={() => onDeleteTask(task.index)}
                fontSize="small"
                className="cursor-pointer"
                component={TrashIcon}
              />
            )}
          >
            <SvgIcon
              sx={{
                mr: 1,
              }}
              component={DragIcon}
            />
            <Typography variant="body2">{task.taskName}</Typography>
          </ListItem>
        )}
      </Draggable>
    ))}
  </div>
);

export {
  DraggableTasks,
};
